import React from 'react';

const InputField = ({ label, name, defaultValue, value, onChange, register, explanation, rules, error }) => {
    const reg = register ? {...register(name, rules)} : {
        onChange,
        name,
        value
    };
    return (
        <div className='mb-3 flex flex-col w-full'>
            <label className='text-brandDarkBlue text-sm font-bold pr-6 mb-1'>{label} {rules && <span className='text-red'>*</span>}</label>
            <input
                type="text"
                {...reg}
                defaultValue={defaultValue}
                className={`bg-white h-12 py-1 px-4 w-full text-black ${error ? 'border border-red focus:outline-red' : ''}`}
            />
            {explanation && (
                <span className='text-brandDarkBlue text-xs text-gray-500 my-1'>{explanation}</span>
            )}
            {error && <span className='text-red text-xs'>{error}</span>}
        </div>
    )
};

export default InputField;